// src/components/pages/correlation/utils/analysisTextGenerator.js

import DOMPurify from 'dompurify';

export function generateCorrelationAnalysis(stocks, correlationMatrix, t) {
  const sanitizedStocks = stocks.map(stock => DOMPurify.sanitize(stock, { USE_PROFILES: { html: false } }));
  
  const highCorrPairs = [];
  const lowCorrAssets = new Set(sanitizedStocks);

  sanitizedStocks.forEach((stockA, i) => {
    sanitizedStocks.forEach((stockB, j) => {
      if (i < j) {
        const corr = correlationMatrix[i][j];
        if (corr >= 0.7) {
          highCorrPairs.push({ pair: [stockA, stockB], value: corr.toFixed(2) });
        }
        if (corr >= 0.3) {
          lowCorrAssets.delete(stockA);
          lowCorrAssets.delete(stockB);
        }
      }
    });
  });

  const analysis = [];

  if (highCorrPairs.length > 0) {
    analysis.push(t("correlation.analysis.highCorrWarning"));
    analysis.push("");
    analysis.push(t("correlation.analysis.correlationListTitle"));
    analysis.push("");

    const groupMap = {};
    highCorrPairs.forEach(pairObj => {
      const base = pairObj.pair[0];
      const other = pairObj.pair[1];
      if (!groupMap[base]) groupMap[base] = [];
      groupMap[base].push({ other: other, value: pairObj.value });
    });

    for (const base in groupMap) {
      analysis.push(t("correlation.analysis.groupHeader", { group: DOMPurify.sanitize(base, { USE_PROFILES: { html: false } }) }));
      groupMap[base].forEach(item => {
        analysis.push(t("correlation.analysis.highCorrPairItem", { other: DOMPurify.sanitize(item.other, { USE_PROFILES: { html: false } }) }));
      });
      analysis.push("");
    }
  } else {
    analysis.push(t("correlation.analysis.noHighCorr"));
  }

  if (lowCorrAssets.size > 0) {
    analysis.push(t("correlation.analysis.lowCorrAssetsTitle"));
    lowCorrAssets.forEach(asset => {
      analysis.push(t("correlation.analysis.lowCorrAssetItem", { asset: DOMPurify.sanitize(asset, { USE_PROFILES: { html: false } }) }));
    });
  } else {
    analysis.push(t("correlation.analysis.allAssetsCorrelated"));
  }

  return analysis.join("\n");
}